/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Company } from "./Company";
import {
  CompanyFromJSON,
  CompanyFromJSONTyped,
  CompanyToJSON,
  CompanyToJSONTyped,
} from "./Company";
import type { CustomerInvoice } from "./CustomerInvoice";
import {
  CustomerInvoiceFromJSON,
  CustomerInvoiceFromJSONTyped,
  CustomerInvoiceToJSON,
  CustomerInvoiceToJSONTyped,
} from "./CustomerInvoice";

/**
 *
 * @export
 * @interface CompanyCustomerInvoice
 */
export interface CompanyCustomerInvoice {
  /**
   *
   * @type {Company}
   * @memberof CompanyCustomerInvoice
   */
  company: Company;
  /**
   *
   * @type {CustomerInvoice}
   * @memberof CompanyCustomerInvoice
   */
  customerInvoice: CustomerInvoice;
}

/**
 * Check if a given object implements the CompanyCustomerInvoice interface.
 */
export function instanceOfCompanyCustomerInvoice(
  value: object,
): value is CompanyCustomerInvoice {
  if (!("company" in value) || value["company"] === undefined) return false;
  if (!("customerInvoice" in value) || value["customerInvoice"] === undefined)
    return false;
  return true;
}

export function CompanyCustomerInvoiceFromJSON(
  json: any,
): CompanyCustomerInvoice {
  return CompanyCustomerInvoiceFromJSONTyped(json, false);
}

export function CompanyCustomerInvoiceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyCustomerInvoice {
  if (json == null) {
    return json;
  }
  return {
    company: CompanyFromJSON(json["company"]),
    customerInvoice: CustomerInvoiceFromJSON(json["customerInvoice"]),
  };
}

export function CompanyCustomerInvoiceToJSON(
  json: any,
): CompanyCustomerInvoice {
  return CompanyCustomerInvoiceToJSONTyped(json, false);
}

export function CompanyCustomerInvoiceToJSONTyped(
  value?: CompanyCustomerInvoice | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    company: CompanyToJSON(value["company"]),
    customerInvoice: CustomerInvoiceToJSON(value["customerInvoice"]),
  };
}
